

import {useState,createContext,useContext} from 'react';
import { useSelector } from 'react-redux';

const AuthContext=createContext({});




export const AuthProvider=({children})=>{
    const [auth,setAuth]=useState();
    const [searchDataGrid, setSearchDataGrid] = useState("")
    const login=(data)=>{
     setAuth(data)
    }
    const logout=()=>{
    setAuth(null)
    }

    return(
        <AuthContext.Provider value={{auth,login,logout,searchDataGrid, setSearchDataGrid }}>
        {children}
        </AuthContext.Provider>
    )


}

export const useAuth=()=>{
return useContext(AuthContext)
}

export default AuthContext